var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoveRectangle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Huge-icon/interface/outline/remove-rectangle",
    clipPath: "url(#clip0_1332_5500)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.64927 6.07404L5.34943 9.37387M8.64927 9.37388L5.34943 6.07404M10.4993 1.89062H3.49935C2.21068 1.89062 1.16602 2.93529 1.16602 4.22396V11.224C1.16602 12.5126 2.21068 13.5573 3.49935 13.5573H10.4993C11.788 13.5573 12.8327 12.5126 12.8327 11.224V4.22396C12.8327 2.93529 11.788 1.89062 10.4993 1.89062Z",
    stroke: "#ED2121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1332_5500"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.722656)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveRectangle);
export default __webpack_public_path__ + "static/media/remove-rectangle.adaf2c273845235cc7144149c65042f8.svg";
export { ForwardRef as ReactComponent };